// Commission rules slice — built from the shared rules reducer factory, so it
// and the clawback slice cannot drift apart.

import * as types from '../../lib/actionTypes.es6';
import { createRulesReducer } from '../../components/CommissionsShared/rulesReducerFactory.es6';

var reducer = createRulesReducer({
  list: {
    request: types.GET_COMMISSION_RULES_REQUEST,
    success: types.GET_COMMISSION_RULES_SUCCESS,
    failure: types.GET_COMMISSION_RULES_FAILURE
  },
  detail: {
    request: types.GET_COMMISSION_RULE_REQUEST,
    success: types.GET_COMMISSION_RULE_SUCCESS,
    failure: types.GET_COMMISSION_RULE_FAILURE
  },
  create: {
    request: types.CREATE_COMMISSION_RULE_REQUEST,
    success: types.CREATE_COMMISSION_RULE_SUCCESS,
    failure: types.CREATE_COMMISSION_RULE_FAILURE,
    reset: types.RESET_CREATE_COMMISSION_RULE_SUCCESS,
    resetError: types.RESET_CREATE_COMMISSION_RULE_ERROR
  },
  update: {
    request: types.UPDATE_COMMISSION_RULE_REQUEST,
    success: types.UPDATE_COMMISSION_RULE_SUCCESS,
    failure: types.UPDATE_COMMISSION_RULE_FAILURE,
    reset: types.RESET_UPDATE_COMMISSION_RULE_SUCCESS,
    resetError: types.RESET_UPDATE_COMMISSION_RULE_ERROR
  },
  validate: {
    request: types.VALIDATE_COMMISSION_RULE_REQUEST,
    success: types.VALIDATE_COMMISSION_RULE_SUCCESS,
    failure: types.VALIDATE_COMMISSION_RULE_FAILURE,
    reset: types.RESET_VALIDATE_COMMISSION_RULE
  },
  setToEdit: types.SET_COMMISSION_RULE_TO_EDIT,
  resetToEdit: types.RESET_COMMISSION_RULE_TO_EDIT
});

export var initialState = reducer.initialState;
export default reducer;
